import React, { Component } from 'react';
import classNames from 'classnames';
import { Button, Input, Icon, Select, Autocomplete, Checkbox } from 'components/antd';
import { Fragment, Align } from 'components';

import styles from './TableBuilder.module.scss';
import { SelectValue } from 'antd/lib/select';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

const ALL_VALUE = 'all';
interface TableCellHeaderProps {
	isClearBtnVisible?: boolean;
	col: any;
	pageConfig: any;
	isLastCol: any;
	handleSearch: any;
	selectsData: any;
	scroll?: any;
	clearFilters: () => void;
	isLoading?: boolean;
}

class TableCellHeader extends Component<TableCellHeaderProps> {
	handleSearch = (e: React.ChangeEvent<HTMLInputElement>, col?: any) => {
		const value = e.target.value;

		if (col.searchParam) {
			this.props.handleSearch(
				{
					[col.searchParam]: value,
				},
				this.isNoNeedRetrieve(col, value)
			);
		}
	};

	isNoNeedRetrieve(col: any, value: string) {
		// TODO: move to func
		return !col.shortSearchText && value.length < 3 && value.length !== 0;
	}

	handleSelect = (selectValue: SelectValue, searchBy?: string) => {
		if (searchBy) {
			this.props.handleSearch({
				[searchBy]: selectValue !== ALL_VALUE ? selectValue : undefined,
			});
		}
	};

	handleCheckbox = (e: CheckboxChangeEvent, col?: any) => {
		const value = e.target.checked;

		if (col.searchParam) {
			this.props.handleSearch({
				[col.searchParam]: value,
			});
		}
	};

	getSortIcon = () => {
		// TODO: move to separate file
		const { col, pageConfig } = this.props;

		if (!col.sorter) {
			return null;
		}

		let isAscending = undefined;

		if (pageConfig['order.OrderColumn'] === col.orderColumn) {
			isAscending = pageConfig['order.OrderByAscending'];
		} else {
			return <Icon type="sortDefault" />;
		}

		if (isAscending) {
			return <Icon type="sortDesc" />;
		} else {
			return <Icon type="sortAsc" />;
		}
	};

	getSelectValue() {
		const { pageConfig, col } = this.props;
		const { searchParam } = col;
		let value = pageConfig[searchParam];

		if (value === undefined) {
			value = col.showSearch ? undefined : ALL_VALUE;
		}

		return value;
	}

	render() {
		const {
			col,
			pageConfig,
			isLastCol,
			isClearBtnVisible,
			selectsData,
			scroll,
			isLoading,
		} = this.props;

		return (
			<Fragment>
				<Fragment>
					<Align
						align={col.align}
						className={classNames(styles.colTitle, {
							[styles.scrollTableHeader]: Boolean(scroll),
						})}
					>
						<span className="titleTextText">{col.titleText}</span>
						{this.getSortIcon()}
					</Align>
					<div
						className={styles.colSortInputWrapper}
						onClick={e => {
							e.stopPropagation();
						}}
					>
						{col.searchParam && !col.isSelect && !col.isCheckbox && (
							<Input
								allowClear
								disabled={isLoading}
								value={pageConfig[col.searchParam]}
								onChange={e => this.handleSearch(e, col)}
							/>
						)}
						{col.searchParam && col.isSelect && !col.showSearch && (
							<Select
								allowClear={pageConfig[col.searchParam] !== undefined}
								value={this.getSelectValue()}
								optionFilterProp="children"
								filterOption={(input: any, option: any) =>
									option.props.children
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
								onChange={e => this.handleSelect(e, col.searchParam)}
								showArrow
								showSearch
							>
								<Select.Option value={ALL_VALUE}>All</Select.Option>
								{selectsData[col.dataIndex].map((item: any) => (
									<Select.Option key={item.id} value={item.id}>
										{item.name}
									</Select.Option>
								))}
							</Select>
						)}
						{col.searchParam && col.isSelect && col.showSearch && (
							<Autocomplete
								dataSource={selectsData[col.dataIndex].map((item: any) => ({
									value: item.id,
									text: item.name,
								}))}
								allowClear={pageConfig[col.searchParam] !== undefined}
								//value={this.getSelectValue()}
								filterOption={(input: any, option: any) =>
									option.props.children
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0
								}
								onSelect={e => this.handleSelect(e, col.searchParam)}
							/>
						)}
						{col.searchParam && col.isCheckbox && (
							<Checkbox
								checked={pageConfig[col.searchParam]}
								onChange={e => this.handleCheckbox(e, col)}
							>
								{col.checkboxLabel}
							</Checkbox>
						)}
						{isLastCol && isClearBtnVisible && (
							<div className={styles.clearWrapper}>
								<Button
									size="small"
									className={styles.clearBtn}
									onClick={this.props.clearFilters}
								>
									Clear
								</Button>
							</div>
						)}
					</div>
				</Fragment>
			</Fragment>
		);
	}
}

export default TableCellHeader;
